import Swiper from 'swiper';

let goodsPropertyDesktop = [];
let goodsPropertyMobile = [];
let goodsSliders = [];

const getActiveSlideIndex = (bullets) => {
  if (bullets && bullets.length) {
    const activeSlideIndex = [...bullets].findIndex((el) => el.classList.contains('swiper-pagination-bullet-active'));

    return activeSlideIndex === -1 ? 0 : activeSlideIndex;
  }
  return 0;
};

const addClassOnSlidePagination = (currSlidePagination, additionalSlidePagination) => {
  const activeSlide = getActiveSlideIndex(additionalSlidePagination);

  currSlidePagination[activeSlide].classList.add('active-on-other-slide');
};

const removeClassFromSlidePagination = (currSlidePagination) => {
  currSlidePagination.forEach((el) => {
    el.classList.remove('active-on-other-slide');
  });
};

const initHandlerTabs = () => {
  const wrapperTabs = document.querySelector('.comparsion__categories-tabs');
  if (!wrapperTabs) {
    return;
  }
  const listNav = wrapperTabs.querySelectorAll('.categories-tabs__link:not(.active)');
  listNav.forEach((item) => {
    if (item.classList.contains('init')) {
      return;
    }
    item.addEventListener('click', (e) => {
      let el = null;
      if (e.target.classList.contains('categories-tabs__link')) el = e.target;
      else el = e.target.closest('.categories-tabs__link');

      if (el) {
        const sectionId = el.dataset.sectionId;
        window.makeRequest(sectionId, true);
      }
    });
    item.classList.add('init');
  });
};

const initComparsion = () => {
  const comparsionGoodsSlider = document.querySelectorAll('.comparsion-goods-slider');
  const comparsionPropertyDesktop = document.querySelectorAll('.comparsion-property-slider--desktop');
  const comparsionPropertyMobile = document.querySelectorAll('.comparsion-property-slider--mobile');

  comparsionPropertyDesktop.forEach((slider) => {
    const mySwiper = new Swiper(slider, {

      freeMode: false,

      spaceBetween: 20,

      speed: 500,
      breakpoints: {
        1180: {
          slidesPerView: 5,
        },
        325: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
      },
    });

    mySwiper.init();

    goodsPropertyDesktop.push(mySwiper);

    goodsSliders.push(mySwiper);
  });

  comparsionPropertyMobile.forEach((slider) => {
    const mySwiper = new Swiper(slider, {

      speed: 500,

      spaceBetween: 20,

      breakpoints: {
        1460: {
          slidesPerView: 3,
        },
        1180: {
          slidesPerView: 2,
        },
        325: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
      },

      init: false,
    });

    mySwiper.init();

    goodsPropertyMobile.push(mySwiper);

    goodsSliders.push(mySwiper);
  });

  let desktopSwiperContainer = null;
  let mobileSwiperContainer = null;
  let desktopPaginationBullets = null;
  let mobilePaginationBullets = null;
  let isInitEvent = true;

  comparsionGoodsSlider.forEach((slider, index) => {
    const mySwiper = new Swiper(slider, {
      speed: 500,
      spaceBetween: 20,
      breakpoints: {
        1180: {
          slidesPerView: 5,
        },
        325: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
      },

      controller: {
        control: index === 0 ? goodsPropertyDesktop : goodsPropertyMobile,
      },

      init: false,

      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 5,
        renderBullet() {
          return '<span class="swiper-pagination-bullet"></span>';
        },
      },
    });

    // let buttonsComparsion = document.querySelectorAll('.button-comparsion')[0];
    if (!desktopSwiperContainer) {
      desktopSwiperContainer = mySwiper.el.closest('.goods-comparsion__desktop');
    }
    if (!mobileSwiperContainer) {
      mobileSwiperContainer = mySwiper.el.closest('.goods-comparsion__mobile');
    }

    if (desktopSwiperContainer) {
      const leftButton = desktopSwiperContainer.querySelectorAll('.arrow-prev')[0];
      const rightButton = desktopSwiperContainer.querySelectorAll('.arrow-next')[0];

      mySwiper.on('slideChange init', () => {
        if (window.innerWidth > 1180 && mySwiper.slides.length < 6) {
          leftButton.style.display = 'none';
          rightButton.style.display = 'none';
        }

        if (mySwiper.isBeginning) {
          leftButton.classList.add('swiper-button-disabled');
        } else {
          leftButton.classList.remove('swiper-button-disabled');
        }
        if (mySwiper.isEnd) {
          rightButton.classList.add('swiper-button-disabled');
        } else {
          rightButton.classList.remove('swiper-button-disabled');
        }

        desktopPaginationBullets = desktopSwiperContainer.querySelectorAll('.swiper-pagination-bullet');
        mobilePaginationBullets = mobileSwiperContainer.querySelectorAll('.swiper-pagination-bullet');

        if (mobilePaginationBullets.length) {
          if (isInitEvent) {
            if (mobilePaginationBullets.length === 1) {
              mobileSwiperContainer.style.display = 'none';
              desktopSwiperContainer.style.width = '100%';
              const swiperSlides = desktopSwiperContainer.querySelectorAll('.swiper-slide');
              swiperSlides.forEach((el) => {
                el.style.width = '100%';
              });

              const bullets = desktopSwiperContainer.querySelector('.swiper-pagination');
              bullets.style.display = 'none';

              const otherMobileSlides = document.querySelectorAll('.properties-comparsion__values-mobile');
              otherMobileSlides.forEach((el) => {
                el.style.display = 'none';
              });

              const otherDesktopSlides = document.querySelectorAll('.properties-comparsion__values-desktop');
              otherDesktopSlides.forEach((el) => {
                el.style.width = '100%';
              });
            }
          }
          const desktopActiveSlideIdx = getActiveSlideIndex(desktopPaginationBullets);
          const mobileActiveSlideIdx = getActiveSlideIndex(mobilePaginationBullets);

          removeClassFromSlidePagination(desktopPaginationBullets);
          removeClassFromSlidePagination(mobilePaginationBullets);

          addClassOnSlidePagination(desktopPaginationBullets, mobilePaginationBullets);
          addClassOnSlidePagination(mobilePaginationBullets, desktopPaginationBullets);

          if (desktopActiveSlideIdx === mobileActiveSlideIdx) {
            if (!isInitEvent) {
              if (mySwiper.activeIndex > mySwiper.previousIndex) {
                mySwiper.slideNext();
              } else {
                mySwiper.slidePrev();
              }
            } else {
              mySwiper.slideNext();
            }

            if (desktopActiveSlideIdx === desktopPaginationBullets.length - 1 && mobileActiveSlideIdx === mobilePaginationBullets.length - 1) {
              mySwiper.slideTo(0);
            } else if (desktopActiveSlideIdx === 0 && mobileActiveSlideIdx === 0 && !isInitEvent) {
              mySwiper.slideTo(mobilePaginationBullets.length - 1);
            }
            if (isInitEvent) {
              isInitEvent = false;
            }
          }
        }
      });
      leftButton.addEventListener('click', () => {
        mySwiper.slidePrev();
      });

      rightButton.addEventListener('click', () => {
        mySwiper.slideNext();
      });

      const showDifferenceCheckbox = document.querySelector('.properties-comparsion__show-diferents');
      if (showDifferenceCheckbox) {
        const slidersCount = desktopSwiperContainer.querySelectorAll('.swiper-slide');
        if (slidersCount.length === 1) {
          showDifferenceCheckbox.style.display = 'none';
        }
      }
    }

    queueMicrotask(() => {
      mySwiper.init();
    });

    goodsSliders.push(mySwiper);

    if (index === 0) {
      goodsPropertyDesktop.forEach((item) => {
        item.controller.control = mySwiper;
      });
    } else {
      goodsPropertyMobile.forEach((item) => {
        item.controller.control = mySwiper;
      });
    }
  });
  initHandlerTabs();
};

const makeRequest = async (sectionId, pushState) => {
  window.loaderShow('#bx_catalog_compare_block');
  const queryString = new URLSearchParams({
    section_id: sectionId,
  });
  const urlPath = `/catalog/compare.php?${sectionId ? queryString : ''}`;
  const response = await fetch(urlPath, {
    method: 'POST',
  });
  const html = await response.text();
  document.querySelector('#bx_catalog_compare_block').innerHTML = html;
  if (pushState) {
    window.history.pushState({
      data: html,
      node: 'bx_catalog_compare_block',
      title: 'Каталог',
      sectionId,
      compare: true,
    }, '', window.location.origin + urlPath);
  }
  initComparsion();
  window.initCompareDeleteItemButtons();
  window.initCompareDifferenceTOggler();
};

window.makeRequest = makeRequest;

function destroyComparison() {
  goodsSliders.forEach((item) => {
    item.destroy();
  });
  goodsSliders = [];
  goodsPropertyDesktop = [];
  goodsPropertyMobile = [];
}

window.initComparsion = initComparsion;
window.destroyComparison = destroyComparison;

initComparsion();

window.reloadOnPopstate = function reloadOnPopstate() {
  window.addEventListener('popstate', (e) => {
    if (e.state.compare) {
      makeRequest(e.state.sectionId, false);
    }
  });
};
